import { render } from "./CircleCloseIcon.vue?vue&type=template&id=d7ae1b8e"
import script from "./CircleCloseIcon.vue?vue&type=script&lang=js"
export * from "./CircleCloseIcon.vue?vue&type=script&lang=js"
script.render = render

export default script